document.addEventListener('DOMContentLoaded', () => {
    const shopifyAppBlocks = document.querySelectorAll('.shopify-section .shopify-app-block');
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.visibility = 'visible';
                observer.unobserve(entry.target);
            }
        });
    };
    shopifyAppBlocks.forEach(block => {
        const blockObserver = new IntersectionObserver(observerCallback, observerOptions);
        blockObserver.observe(block);
    });
});

window.onload = function() {
    if (window.Rebuy && window.Rebuy._status === 'initialized') {
        var rebuyImages = document.querySelectorAll(".rebuy-product-image img");
        rebuyImages.forEach(function(image) {
            if (!image.classList.contains("lazyloaded")) {
                image.classList.add("lazyload");
            }
        });
    }
};

document.addEventListener("DOMContentLoaded", function() {
    function applyBackgroundImages() {
    var iconContainers = document.querySelectorAll('.icon-container, #icon_container');
    iconContainers.forEach(function(container) {
        var bgImage = getComputedStyle(container).backgroundImage;
        if (bgImage !== 'none') {
            bgImage = bgImage.replace('url("', '').replace('")', '');
            container.style.backgroundImage = 'none';
            container.setAttribute('data-bg', bgImage);
            container.classList.add('lazyload');
        }
    });
}

function observeDOMChanges() {
    var observer = new MutationObserver(function(mutationsList, observer) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                applyBackgroundImages();
                observer.disconnect();
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

observeDOMChanges();
applyBackgroundImages();
});
